const normalize = (value) => String(value || '').trim();
const normalizeTarget = (value) => normalize(value).toLowerCase();

const LOCAL_ENV_TARGET = normalizeTarget(process.env.REACT_APP_LOCAL_ENV);
const USE_LOCAL_TARGET = process.env.NODE_ENV === 'development' && Boolean(LOCAL_ENV_TARGET);

function getLocalEnvValue(baseName) {
  if (!USE_LOCAL_TARGET) {
    return '';
  }

  const localKey = `${baseName}_${LOCAL_ENV_TARGET.toUpperCase()}`;
  return normalize(process.env[localKey]);
}

export function getAppEnv(baseName, fallback = '') {
  const localValue = getLocalEnvValue(baseName);
  if (localValue) {
    return localValue;
  }

  return normalize(process.env[baseName]) || fallback;
}

export { LOCAL_ENV_TARGET, USE_LOCAL_TARGET };
